<script setup lang="ts">
import applyGuideSource from '@/content/shop-rules/apply-guide.html?raw';
import { createShopRuleArticle } from '@/utils/shopRuleContent';
import './shop-apply-guide.scss';

const articleHtml = createShopRuleArticle(applyGuideSource);
</script>

<template>
  <main class="shop-apply-guide ignore">
    <article v-html="articleHtml"></article>
  </main>
</template>
